import { doFetch, doPutFetch } from "./apiFetchHelper";

const API_URL = `/api/clientportal`;

export function adminAddMembers(memberData) {
  const members = memberData.members;
  return doPutFetch(`${API_URL}`, { members });
}

export function adminEditMember(memberData) {
  const { member } = memberData;
  return doPutFetch(`${API_URL}/edit`, member);
}

export function adminGetMembers(query) {
  const { page, searchValue } = query;
  const size = 1000;
  const isSearching = typeof searchValue === "string" && searchValue.length > 2;
  const search_URL = `${API_URL}/search?page=${page}&size=${size}&query=${searchValue}`;
  const members_URL = `${API_URL}?page=${page}&size=${size}`;
  if (isSearching) {
    return doFetch(search_URL);
  } else {
    return doFetch(members_URL);
  }
}

export function adminGetActiveMemberCount() {
  // PD-2365: temporarily disable call to get active member count
  // disable vs remove because it'll eventually get updated to provide a more accurate count

  // const url = `${API_URL}/active_member_count`;
  // return doFetch(url);

  if (process.env.REACT_APP_ENV === "development") {
    console.log(
      "NOTE: ActiveMemberCount request purposly disabled in adminApi.js -> adminGetActiveMemberCount()",
    );
  }
  return 0;
}

export function adminGetMember(query) {
  const { member_key } = query;
  const url = `${API_URL}/edit?member_key=${member_key}`;
  return doFetch(url);
}

export default {
  adminAddMembers,
  adminEditMember,
  adminGetMembers,
  adminGetMember,
  adminGetActiveMemberCount,
};
